<template>
<!-- 眼健康档案-查看 -->
    <div class="content">
        <div class="title">个人信息</div>
        <div class="data_content">
            <p>
                <span>姓名</span>
                <span>{{ myfiles.myfilename }}</span>
            </p>
            <p>
                <span>性别</span>
                <span>{{ myfiles.myfilesex == 0 ? '女' : '男' }}</span>
            </p>
            <p>
                <span>年龄</span>
                <span>{{ myfiles.myfileage}}</span>
            </p>
        </div>
        <!-- 选择设备 -->
        <div class="select_device">
            <div class="title">选择设备</div>
            <div class="data_content">
                <p>
                    <span>设备编号</span>
                    <select disabled class="selectBig" name="public-choice" v-model="dataId">
                        <option v-for="coupon in dataList" :key="coupon.index">{{dataId}}</option>
                    </select>
                </p>
            </div>
        </div>
        <!-- 数据来源 -->
        <div class="data_sources">
            <div class="title">选择来源</div>
            <div class="data_content">
                <p>
                    <select disabled class="selectBig" name="public-choice" v-model="comefromid">
                        <option v-for="coupon in comefromList" :key="coupon.index">{{coupon.value}}</option>
                    </select>
                    <span class="comefrom_input">{{comefromcontext}}</span>
                </p>
            </div>
        </div>
        <!-- 视力检查 -->
        <div class="visual_examination">
            <div class="title">视力检查</div>
            <div class="data_content table_content">
                <table border="1" frame="void" rules="all" class="table_eye" cellpadding="20">
                    <tr>
                        <th>眼别</th>
                        <th>裸眼视力<img class="must_fill" src="../assets/icon_xinghao@2x.png"></th>
                        <th>矫正视力<img class="must_fill" src="../assets/icon_xinghao@2x.png"></th>
                        <th>球镜</th>
                        <th>柱镜</th>
                        <th>轴位</th>
                    </tr>
                    <tr>
                        <td class="no_boder">当前左眼</td>
                        <td>
                            <span> {{ lastleftid }} </span>
                        </td>
                        <td>
                            <span> {{ lefteyecountid}} </span>
                        </td>
                        <td>
                            <span>{{0}}</span>
                        </td>
                        <td>
                            <span>{{0}}</span>
                        </td>
                        <td>
                            <span>{{0}}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="no_boder">当前右眼</td>
                        <td>
                            <span> {{lastrightid}} </span>
                        </td>
                        <td>
                            <span> {{righteyecountid }} </span>
                        </td>
                        <td>
                            <span>{{0}}</span>
                        </td>
                        <td>
                            <span>{{0}}</span>
                        </td>
                        <td>
                            <span>{{0}}</span>
                        </td>
                    </tr>
<!--                    <tr class="yellow">
                        <td class="no_boder"><span>上次左眼</span></td>
                        <td>
                            <span>{{lefteyecountid}}</span>
                        </td>
                        <td>
                            <span>{{0}}</span>
                        </td>
                        <td>
                            <span>{{0}}</span>
                        </td>
                        <td>
                            <span>{{0}}</span>
                        </td>
                        <td>
                            <span>{{0}}</span>
                        </td>
                    </tr>
                    <tr class="yellow">
                        <td class="no_boder"><span>上次右眼</span></td>
                        <td>
                            <span>{{righteyecountid}}</span>
                        </td>
                        <td>
                            <span>{{0}}</span>
                        </td>
                        <td>
                            <span>{{0}}</span>
                        </td>
                        <td>
                            <span>{{0}}</span>
                        </td>
                        <td>
                            <span>{{0}}</span>
                        </td>
                    </tr>-->
                    <tr>
                        <td class="no_boder">度数差-左</td>
                        <td>
                            <span>{{left_differ[0]}}</span>
                        </td>
                        <td>
                            <span>{{left_differ[1]}}</span>
                        </td>
                        <td>
                            <span>{{left_differ[2]}}</span>
                        </td>
                        <td>
                            <span>{{left_differ[4]}}</span>
                        </td>
                        <td>
                            <span>{{left_differ[3]}}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="no_boder">度数差-右</td>
                        <td>
                            <span>{{right_differ[0]}}</span>
                        </td>
                        <td>
                            <span>{{right_differ[1]}}</span>
                        </td>
                        <td>
                            <span>{{right_differ[2]}}</span>
                        </td>
                        <td>
                            <span>{{right_differ[4]}}</span>
                        </td>
                        <td>
                            <span>{{right_differ[3]}}</span>
                        </td>
                    </tr>
                </table>
                <div class="tips">
                    <p class="tips_p">友情提示</p>
                    <span>{{tips}}</span>
                    <!-- <span>左眼：</span><input class="tips_input" type="text" maxlength="10" v-model="left_tips"> -->
                    <!-- <span >右眼：</span><input class="tips_input" type="text" maxlength="10" v-model="right_tips"> -->
                </div>
            </div>
        </div>

        <!-- 眼健康状况调查 -->
        <div class="eye_health">
            <div class="title"><img class="eye_health_img" src="../assets/icon_xinghao@2x.png">眼健康状况调查</div>
            <div class="data_content">
                <van-checkbox-group v-model="eye_health_result">
                    <van-checkbox checked-color="#eac645" name="yangan">眼干</van-checkbox>
                    <van-checkbox checked-color="#eac645" name="suanse">眼部酸涩</van-checkbox>
                    <van-checkbox checked-color="#eac645" name="zhangtong">眼部胀痛</van-checkbox>
                    <van-checkbox checked-color="#eac645" name="liulei">眼部流泪</van-checkbox>
                    <van-checkbox checked-color="#eac645" name="shuimian">睡眠质量</van-checkbox>
                    <van-checkbox checked-color="#eac645" name="touteng">头疼</van-checkbox>
                    <van-checkbox checked-color="#eac645" name="yanquan">黑眼圈</van-checkbox>
                    <van-checkbox checked-color="#eac645" name="yandai">眼袋</van-checkbox>
                    <van-checkbox checked-color="#eac645" name="fuzhong">眼部浮肿</van-checkbox>
                </van-checkbox-group>
            </div>
        </div>

        <!-- 其他 -->
        <div class="describe">
            <div class="title">其他眼部情况：</div>
            <div class="textarea_div">
                <textarea disabled class="textarea" v-model="describe" rows="5" cols="40" maxlength="500" placeholder="请输入您的详细描述(最多500字)"></textarea>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { Popup } from 'vant';
import { Checkbox, CheckboxGroup } from 'vant';
import { RadioGroup, Radio } from 'vant';
import { Toast } from 'vant';


Vue.use(Toast);
Vue.use(Popup);
Vue.use(Checkbox).use(CheckboxGroup);
Vue.use(RadioGroup);
Vue.use(Radio);

export default {
    data() {
        return {
            myfiles: {},

            checked: true,
            comefromcontext: '',    //来源描述
            describe: '',       //其他描述
            eye_health_result: [],  // 眼睛情况
            lastleftid:'',
            lastrightid:'',
            lefteyecountid:'',
            righteyecountid:'',


            left_differ: [],
            right_differ:[],


            tips: '',
            // 上次左眼
            lastleft: {},
            // 当前左
            leftcount: {},
            // 当前右
            rightcount: {},
            // 上次右眼
            lastright: {},
            // 选择数据来源
            comefromid: '',
            comefromList: [
                {key: -1, value: "请选择"},
                {key: 1, value: "眼镜店"},
                {key: 2, value: "医院检查"},
                {key: 3, value: "自查"}
            ],
            // 选择设备
            dataId: '',
            dataList: [
                {
                    key: -1, value: "请选择"
                },
                {
                    key: 1, value: "0a180096"
                }
            ],
            myfilename: '',
        };
    },
    created() {
        this.getDataList()
        this.getData()
    },
    methods: {
        // 获取
        getDataList() {
            this.axios.get('/weixin/getEye',{
                params: {
                    myfileid: this.$route.params.myfileid,
                    eyeid: this.$route.params.eyeid
                }
            })
            .then(res=>{

                let data = res.data
                this.myfiles = data

                this.comefromcontext = data.comefromcontext
                this.dataId = data.instrumentid[0]
                this.comefromid = this.comefromList[data.comefrom].value
                this.lastleftid=data.lastleftid
                this.lastrightid=data.lastrightid
                this.lefteyecountid=data.lefteyecountid
                this.righteyecountid=data.righteyecountid
                this.describe = data.other
                this.tips = data.tishi
                this.rightcount = data.rightcount
                this.leftcount = data.leftcount
                if(data.lastleft) {
                    this.lastleft = data.lastleft
                    this.getdiffer()
                }
                if(data.lastright) {
                    this.lastright = data.lastright
                    this.getdiffer()
                }
                let arr = []
                let arr1 = [
                    'yangan',
                    'suanse',
                    'zhangtong',
                    'liulei',
                    'shuimian',
                    'touteng',
                    'yanquan',
                    'yandai',
                    'fuzhong'
                ]
                arr1.map(i=>{
                    for(let k in data){
                        if( k == i) {
                            if(data[k] == 1) {
                                this.eye_health_result.push(k)
                            }
                        }
                    }
                })
            })
        },

        // 获取个人信息
        getData() {
            this.axios.get('/weixin/getMyfileByid', {
                params: {
                    myfileid: this.$route.params.myfileid
                }
            })
            .then(res=>{
                function fn (a) {
                let arr = []
                for (let i in a) {
                    arr.push(a[i]);
                }
                return arr.slice(1)
            }
                this.myfiles = res.data

                this.myfilename = res.data.myfilename
            })
        },

        // 求差
        getdiffer() {
            function fn (a) {
                let arr = []
                for (let i in a) {
                    arr.push(a[i]);
                }
                return arr.slice(1)
            }

            // 当前左
            let left_current = fn(this.leftcount)
            // // 当前右
            let right_current = fn(this.rightcount)
            // // 上次左
            let last_left = fn(this.lastleft)
            // // 上次右
            let last_right = fn(this.lastright)

            // 当前 减去 上次
            this.left_differ = left_current.map((val,index)=>((val - last_left[index]).toFixed(2)));
            this.right_differ = right_current.map((val,index)=>((val - last_right[index]).toFixed(2)));
        }
    },
    components: {

    },
};
</script>

<style>
.van-toast--html, .van-toast--text {
    min-width: 3.56rem;
    min-height: 50px;
}
.van-checkbox {
    height: 84px;
    line-height: 84px;
    border-bottom: 2px solid #f0f0f0;
    font-size: 34px;
    color: #333;
    letter-spacing: 4px;
}
.van-checkbox:last-child {
    border-bottom: none;
}

.van-checkbox__icon {
    height: 34px;
    line-height: 34px;

}

.van-checkbox__icon .van-icon {
    border: 2px solid #eac645;
    width: 36px;
    height: 36px;
}

.van-checkbox__label {
    line-height: normal;
}
.van-radio__icon .van-icon {
    border: 2px solid #eac645;
}

.van-radio-group {
    padding: 28px;
}

.van-popup--center {
    width: 400px;
    top: 50%;
}
.van-radio {
    height: 50px;
    margin-bottom: 20px;
}


/* .van-radio__icon--checked .van-icon {
    background-color: #eac645 !important;
    border: 2px solid #eac645 !important;
} */

.van-radio__label {

    margin-left: 40px;
}
</style>

<style scoped>
select {
    color: #333;
    /*Chrome和Firefox里面的边框是不一样的，所以复写了一下*/
    border: 2px solid #eac645;
    border-radius: 30px;
    /*很关键：将默认的select选择框样式清除*/
    appearance:none;
    -moz-appearance:none;
    -webkit-appearance:none;
    /*在选择框的最右侧中间显示小箭头图片*/
    outline:none;
}
/*清除ie的默认选择框样式清除，隐藏下拉箭头*/
select::-ms-expand { display: none; }

.selectBig {
    width: 300px;
    height: 54px;
    font-size: 38px;
    background: url("../assets/icon_qingxuanze@2x.png") no-repeat scroll right center transparent;
    background-position-x: 260px;
    background-size: 24px;
    padding-right: 60px;
    padding-left: 12px;
}

.eyeSelect {
    text-align:left;
    font-size: 28px;
    display: inline-block;
    border: 2px solid #eac645;
    border-radius: 30px;
    margin: 18px 6px;
    width: 148px;
    height: 42px;
    line-height: 42px;
    background: url("../assets/icon_shili@2x.png") no-repeat scroll right center transparent;
    background-position-x: 136px;
    background-size: 18px;
    padding-left: 10px;
}


td, th {
    text-align: center;
    line-height: 82px;
}

.title {
    padding: 28px;
}
.data_content {
    padding: 0 28px;
    background: #fff;
}

.data_content p {
    height: 92px;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 38px;
}

.data_content p:last-child {
    border-bottom: none;
}
.table_content {
    padding: 10px;
}

.table_eye {
    width: 100%;
    border-left: none;
}


td {
    border: none;
    border-left: 2px solid #f0f0f0;
    border-bottom: 2px solid #f0f0f0;
}

.no_boder {
    border-left: none;
}

th {
    border: none;
    border-bottom: 2px solid #f0f0f0;

}



.eye_input {
    width: 70px;
    height: 42px;
    border: none;
    text-align: center;
}

.must_fill {
    width: 10px;
    vertical-align: super;
    margin-left: 4px;
}

.yellow {
    color: #eac645;
}

.tips {
    line-height: 82px;
    font-size: 34px;
    border-top: 2px solid #f0f0f0;
}
.tips .tips_p {
    border-bottom: none;
    display: inline-block;
    height: 82px;
    padding-right: 30px;
    line-height: 82px;
}
.tips_input {
    width: 180px;
    border: none;
}

.eye_health_img {
    width: 10px;
    vertical-align: super;
    margin-right: 10px;
}

.textarea_div {
    padding: 0 28px 28px;
}

.textarea {
    resize:none;
    width: 100%;
    height: 194px;
    text-indent: 30px;
    background: #fff;
    border: none;
    border-radius: 30px;
    font-size: 32px;
    color: #333;
}
.comefrom_input {
    width: 350px;
    border: none;
}

.comefrom_img {
    width: 26px;
    margin-left: 10px;
}

.submit {
    width: 100%;
    background: #eac645;
    color: #fff;
    border-radius: 20px;
    height: 96px;
    margin-bottom: 30px;
}

.p_input {
    position: relative;
}

.span_checbox {
    display: block;
    width: 36px;
    height: 36px;
    position: absolute;
    background: #fff;
    border: 2px solid #cfcfcf;
    border-radius: 50%;
}

.span_checked {
    display: block;
    width: 36px;
    height: 36px;
    position: absolute;
    background: #eac645;
    border: 2px solid #eac645;
    content: "\2714";
    color: #fff;
    text-align: center;
    border-radius: 50%;
}

.input_text {
    font-size: 34px;
    display: inline-block;
    margin-left: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/ModifyFiles.vue